import React from 'react';

export type AssociatedRunsContextType = {
  onShowAssociatedRuns?: (displayName: string) => void;
};

export const AssociatedRunsContext = React.createContext<AssociatedRunsContextType>({});
